import { surveyFormStore } from "../stores";

export const useSurveyFormStore = () => surveyFormStore;
